module.exports = __webpack_public_path__ + "static/media/logo_m68_small.9b3ce15b.svg";